export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"MEM22 Akademi, milli sporcu Mehmet Emin Musaoğlu rehberliğinde birebir motosiklet, enduro ve süper enduro teknik eğitimleri sunar. Online videolarla veya parkurda, teknik gelişiminizi hızlandırın."},{"name":"keywords","content":"mem22, mem 22, mem22 akademi, mehmet emin musaoğlu, milli sporcu eğitimi, enduro eğitimi, çocuk motor kursu, süper enduro, teknik motosiklet eğitimi, birebir motosiklet dersi, motosiklet sürüş teknikleri, motosiklet kontrol eğitimi, offroad eğitimi, viraj teknikleri, frenleme teknikleri, denge eğitimi, yarış eğitimi, online motosiklet kursu, motosiklet eğitim videoları, profesyonel enduro eğitmeni, sürüş simülasyonu, kask kamerası eğitimleri, sporcu sürücü gelişimi"},{"name":"author","content":"MEM22 Akademi"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"property":"og:title","content":"MEM22 Akademi"},{"property":"og:description","content":"Yeni videolarla teknik gelişimine hız kazandır!"},{"property":"og:image","content":"https://mem22.com/og-image.jpg"},{"property":"og:url","content":"https://mem22.com"},{"name":"twitter:card","content":"summary_large_image"}],"link":[{"rel":"icon","href":"/favicon.ico","type":"image/x-icon"},{"rel":"icon","sizes":"192x192","href":"/web-app-manifest-192x192.png","type":"image/png"},{"rel":"icon","sizes":"512x512","href":"/web-app-manifest-512x512.png","type":"image/png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"manifest","href":"/site.webmanifest"}],"style":[],"script":[],"noscript":[],"title":"MEM22 Akademi | Teknik Eğitim Platformu"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true